import { registerSW } from 'virtual:pwa-register'

// Poll for a new SW every 60s. When one is found, activate it immediately
// and reload the tab once it takes control — users get the new build without
// any manual action (no hard-refresh, no cache clear).
export function registerPwaUpdater(): void {
    if (typeof window === 'undefined') return
    if (!('serviceWorker' in navigator)) return

    let reloading = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloading) return
        reloading = true
        window.location.reload()
    })

    const updateSW = registerSW({
        immediate: true,
        onRegisteredSW(_swUrl, registration) {
            if (!registration) return
            // Check for a new SW once per minute while the tab is open.
            setInterval(() => {
                void registration.update()
            }, 60 * 1000)
        },
        onNeedRefresh() {
            // New SW waiting → ask it to skipWaiting. The controllerchange
            // listener above will then reload the page.
            void updateSW(true)
        },
    })
}
